import React from "react";
import { logout } from "../../utils/msalAuth";
import "./SideNavProfile.css";
import useProfile from "../../hooks/useProfile";
import { FormattedMessage } from "react-intl";

const SideNavProfile = ({ isExpanded }) => {
  const { profile } = useProfile();

  if (!(profile?.surname || profile?.givenName)) return null;
  return (
    <div>
      <hr style={{ margin: 0 }} />
      <div className="nav-profile">
        {profile?.image ? (
          <img
            src={profile?.image}
            alt="profile pic"
            className="nav-profile-pic"
            height={40}
            width={40}
          />
        ) : (
          <span
            className="nav-profile-pic"
            title={`${profile?.givenName} ${profile?.surname}`}
          >
            {profile?.givenName.charAt(0)}
            {profile?.surname.charAt(0)}
          </span>
        )}
        {!!isExpanded && (
          <div className="nav-prof-name-container">
            <p className="nav-prof-name">
              {profile?.givenName} {profile?.surname}
            </p>
            <button className="nav-signout" onClick={logout}>
              <FormattedMessage id="navbar.signout" defaultMessage="SignOut" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideNavProfile;
